import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Api from '../../services/api'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {
  faEnvelope,
  faTimes
} from '@fortawesome/fontawesome-free-solid'

/*
 * Emails the catalogue of an Offer Board - the same choice an auction
 * catalogue offers, the summary or the Lots in full detail, only the board is
 * its own resource so it is asked for from its own endpoint.
 */
class EmailModalOfferBoard extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      recipientName: this.props.userData.firstName,
      recipientEmail: this.props.userData.email
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.sendEmailRequest = this.sendEmailRequest.bind(this)
  }

  handleInputChange ({ target: { name, value } }) {
    this.setState({
      [name]: value
    })
  }

  async sendEmailRequest (docType) {
    if (!this.props.offerBoard) {
      return
    }
    this.props.showSpinner(true)
    let res = await Api.emailOfferBoardInfo({
      offerBoardId: this.props.offerBoard._id,
      data: {
        recipientName: this.state.recipientName,
        recipientEmail: this.state.recipientEmail,
        docType
      }
    })
    if (res && res.success) {
      this.props.showModal({
        title: 'FarmGate',
        message: res.success
      })
      this.props.closeModal()
    }
    this.props.showSpinner(false)
  }

  render () {
    return (
      <Modal
        isOpen={this.props.isOpen}
        onAfterOpen={this.props.afterOpenModal}
        onRequestClose={this.props.closeModal}
        ariaHideApp={false}
        overlayClassName='overlay'
        className='content'
        portalClassName='ReactModalPortal-Email'
      >
        <h2 className='modal-header'>Email Catalogue</h2>
        <span className='icon-close icon-danger' onClick={this.props.closeModal}>
          <FontAwesomeIcon icon={faTimes} />
        </span>
        <div className='modal-body'>
          <input
            type='text'
            name='recipientName'
            placeholder='Name'
            className='modal-input'
            onChange={this.handleInputChange}
            defaultValue={this.state.recipientName} />
          <input
            type='text'
            name='recipientEmail'
            placeholder='Email'
            className='modal-input'
            onChange={this.handleInputChange}
            defaultValue={this.state.recipientEmail} />
          <h3 className='choice-desc'>
            Please choose if you would like to email a summary of the catalogue or the catalogue in full detail.
          </h3>
          <div className='buttons'>
            <div className='button' onClick={() => this.sendEmailRequest('summary')}>
              <span className='button-text'>Summary Catalogue</span>
              <span className='icon-wrapper'><FontAwesomeIcon icon={faEnvelope} /></span>
            </div>
            <div className='button' name='fullDetail' onClick={() => this.sendEmailRequest('full')}>
              <span className='button-text'>Lots in Full Detail</span>
              <span className='icon-wrapper'><FontAwesomeIcon icon={faEnvelope} /></span>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

EmailModalOfferBoard.propTypes = {
  closeModal: PropTypes.func.isRequired,
  afterOpenModal: PropTypes.func,
  isOpen: PropTypes.bool.isRequired,
  offerBoard: PropTypes.object
}

EmailModalOfferBoard.defaultProps = {
  afterOpenModal: () => {}
}

export default EmailModalOfferBoard
